import React from 'react';

/**
 * Page showing notes for a specific agent within the agency.
 */
export const AgentNotes = () => {
  return (
    <div>
      <h2>Agent Notes</h2>
    </div>
  );
};
